module.exports = __webpack_public_path__ + "img/cuoti_null.56c03960.png";